<template>
    <header class="widget-header">
        <p class="title">
            <slot />
        </p>
        <base-select
            v-if="sortedShows"
            :options="sortedShows"
            initial-value="all"
            @change="value => $emit('change', value)"
        />
    </header>
</template>

<script>
import { mapState } from 'vuex';
import {
    chain,
    filter,
} from 'lodash';

export default {
    props: {
        playersType: {
            type: String,
            required: true,
        },
    },

    data: () => ({
        defaultSelect: [
            {
                label: 'All Shows',
                value: 'all',
            },
        ],
    }),

    computed: {
        ...mapState([
            'shows',
        ]),

        /**
         * Get single show
         *
         * @returns  {Array}  Sorted shows values.
         */
        sortedShows() {
            if (! this.shows) {
                return false;
            }

            let sortedShows = chain(this.shows)
                .sortBy('title')
                .filter('isValid')
                .value();

            if ('archive' === this.playersType) {
                sortedShows = filter(sortedShows, 'isPro');
            }

            const shows = sortedShows.map(show => ({ label: show.title, value: show.hash }));

            return [...this.defaultSelect, ...shows];
        },
    },
};
</script>
